/**
 * 프로젝트 테이블 아이템 형태 정의
 * 서버 응답을 테이블에서 사용할 수 있는 형태로 변환하기 위한 구조 정의
 */

/**
 * 테이블에서 사용하는 프로젝트 아이템의 필드 구조
 */
export const PROJECT_TABLE_ITEM_SCHEMA = Object.freeze({
  id: null,                    // number - 프로젝트 ID
  name: null,                  // string - 프로젝트명
  description: null            // string - 프로젝트 설명
});

/**
 * 서버 응답 데이터를 테이블 아이템 형태로 변환하는 함수
 * @param {Object} serverItem - 서버에서 받은 프로젝트 객체
 * @returns {Object} 테이블에서 사용할 수 있는 형태의 아이템 객체
 */
export function transformToProjectTableItem(serverItem) {
  if (!serverItem) {
    return null;
  }

  return {
    id: serverItem?.id ?? null,
    name: serverItem?.name ?? null,
    description: serverItem?.description ?? null
  };
}

/**
 * 서버 응답 배열을 테이블 아이템 배열로 일괄 변환하는 함수
 * @param {Array<Object>} serverItems - 서버에서 받은 프로젝트 객체 배열
 * @returns {Array<Object>} 테이블에서 사용할 수 있는 형태의 아이템 객체 배열
 */
export function transformToProjectTableItems(serverItems) {
  if (!Array.isArray(serverItems)) {
    return [];
  }

  return serverItems
    .map(item => transformToProjectTableItem(item))
    .filter(item => item !== null);
}

